import { ResponseError } from '@backstage/errors';

class LinguistClient {
  discoveryApi;
  fetchApi;
  constructor(options) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
  }
  async getLanguages(entityRef) {
    const queryString = new URLSearchParams();
    queryString.append("entityRef", entityRef);
    const urlSegment = `entity-languages?${queryString}`;
    const items = await this.get(urlSegment);
    return items;
  }
  async get(path) {
    const baseUrl = `${await this.discoveryApi.getBaseUrl("linguist")}/`;
    const url = new URL(path, baseUrl);
    const response = await this.fetchApi.fetch(url.toString());
    if (!response.ok) {
      throw await ResponseError.fromResponse(response);
    }
    return response.json();
  }
}

export { LinguistClient };
//# sourceMappingURL=LinguistClient.esm.js.map
